const COMMON_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'ymail.com',
  'rocketmail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'proton.me',
  'protonmail.com',
  'pm.me',
  'zoho.com',
  'mail.com',
  'gmx.com',
  'gmx.net',
  'yandex.com',
  'comcast.net',
  'verizon.net',
  'att.net',
  'sbcglobal.net',
]);

const DOMAIN_PATTERN = /^(?=.{1,253}$)(?!-)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;

export const normalizeDomain = (domain) => {
  return (domain || '')
    .trim()
    .toLowerCase()
    .replace(/^@+/, '')
    .replace(/\.+$/, '');
};

export const isCommonEmailDomain = (domain) => {
  return COMMON_EMAIL_DOMAINS.has(normalizeDomain(domain));
};

export const validateOrganizationDomain = (domain) => {
  const normalized = normalizeDomain(domain);

  if (!normalized) {
    return 'Organization domain is required';
  }

  if (!DOMAIN_PATTERN.test(normalized)) {
    return 'Invalid domain format. Example: university.edu or organization.org';
  }

  if (isCommonEmailDomain(normalized)) {
    return 'Common personal email domains cannot be used for an organization. Enter your school or organization domain.';
  }

  return null;
};

export const assertValidOrganizationDomain = (domain) => {
  const validationError = validateOrganizationDomain(domain);
  if (validationError) {
    throw new Error(validationError);
  }
  return normalizeDomain(domain);
};
